import Header from "./Header";
import MusicLoader from "./icons/Loader";
import { useRecognizeFlow } from "../Hooks/useRecognizeFlow";
import "../Styles/RecognizeSong.css";
import { useNavigate } from "react-router-dom";

export default function RecognizeSong() {
  const {
    gate,
    ctx,
    step,
    result,
    cover,
    mood,
    posting,
    refreshGate,
    chooseVenue,
    startRecognize,
    stop,
    setMood,
    goToMood,
    postToVenue,
  } = useRecognizeFlow();

  const navigate = useNavigate();
  const showVenuePicker =
    gate.status === "allowed" && (gate.candidates?.length ?? 0) > 1;

  return (
    <div className="master-wrapper">
      <Header />

      <div className="recognize-container">
        {cover && (
          <div
            className="recognize-bg"
            style={{ backgroundImage: `url("${cover}")` }}
            aria-hidden="true"
          />
        )}

        <div className="recognize-content">
          {/* BLOCKED / CHECKING */}
          {step === "checking" && (
            <p className="recognize-status">Checking location…</p>
          )}

          {step === "blocked" && (
            <div style={{ color: "crimson" }}>
              <b>You must be at a venue to recognize.</b>
              <div style={{ marginTop: 8 }}>
                <button type="button" onClick={refreshGate}>
                  Try again
                </button>
              </div>
              {result?.error && <div style={{ marginTop: 8 }}>Reason: {result.error}</div>}
            </div>
          )}

          {/* VENUE FIRST */}
          {step === "pickVenue" && !showVenuePicker && (
            <div className="venue-picker">
              <h2 className="recognize-h2">Pick a venue to continue</h2>
              <button type="button" className="step-button" onClick={refreshGate}>
                Find venues near me
              </button>
            </div>
          )}

          {step === "pickVenue" && showVenuePicker && (
            <div className="venue-picker">
              <h2 className="recognize-h2">Seems like you're close to many places. Please pick the right one</h2>

       
                {gate.candidates.map((v) => (
                  <div className="venue-picker-item" key={v.id} onClick={() => chooseVenue(v.id)}>
                    
                    <p>{v.name}</p><p>-</p><p>{v.distanceM}m</p>
                  </div>
                ))}
          
            </div>
          )}

          {/* READY CTA */}
          {step === "ready" && (
            <>
             
                  <h2 className="recognize-h2">Tap the button to recognize song at&nbsp;
                  {gate.status === "allowed" 
                    ? gate.candidates.find(c => c.id === gate.selectedVenueId)?.name 
                    : ""}
                </h2>
              <button className="recognize-button" onClick={startRecognize}>
                Recognize song
              </button>
            </>
          )}

          {/* RECORDING / UPLOADING */}
          {(step === "recording" || step === "uploading") && (
            <>
              <button className="recognize-button recognizing" onClick={stop}>
                {step === "recording" ? <MusicLoader /> : "Recognizing..."}
              </button>
            </>
          )}

          {/* RESULT */}
          {step === "result" && result?.match && (
            <>
              <div
                className="recognize-match"
                style={{ backgroundImage: `url("${cover}")` }}
              >
                <div className="match-overlay">
                  <div>
                    <p id="song">{result.match.title}</p>
                    <p id="artist">{result.match.artist}</p>
                  </div>
                </div>
              </div>

              <button type="button" className="step-button" onClick={goToMood} style={{ marginTop: 10 }}>
                Continue
              </button>
            </>
          )}

          {/* MOOD (1-tap) */}
          {step === "mood" && (
            <div className="mood-picker">
              <div style={{ marginTop: 10 }}>
                <h2 className="recognize-h2">How’s the vibe?</h2>
              </div>

              <div className="mood-picker-wrapper" style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 }}>
                <button type="button" className="mood-button" onClick={() => setMood("calm")} aria-pressed={mood === "calm"}>
                <span className="mood-emoji">😴</span>Calm
                </button>
                <button type="button" className="mood-button" onClick={() => setMood("nice")} aria-pressed={mood === "nice"}>
                <span className="mood-emoji">🙂</span>Nice
                </button>
                <button type="button" className="mood-button" onClick={() => setMood("lit")} aria-pressed={mood === "lit"}>
                  <span className="mood-emoji">🔥</span>Lit
                </button>
                <button type="button" className="mood-button" onClick={() => setMood("wild")} aria-pressed={mood === "wild"}>
                  <span className="mood-emoji">🤯</span>Wild
                </button>
                <button type="button" className="mood-button" onClick={() => setMood(null)} aria-pressed={mood === null}>
                  Skip
                </button>
              </div>

              <button
                type="button"
                className="step-button"
                onClick={() => postToVenue(mood)}
                disabled={posting}
                style={{ marginTop: 12 }}
              >
                {posting ? "Posting..." : "Post to venue"}
              </button>
            </div>
          )}

          {step === "posting" && <h2 className="recognize-h2">Posting...</h2>}

          {step === "done" && <div className="done-wrapper">
            <h2 className="recognize-h2">Posted ✅</h2>
            <button
                type="button"
                className="step-button"
                onClick={() => navigate("/")}
              >
                Back to feed
              </button>
            </div>}

          {step === "error" && (
            <div className="recognize-error">
              <b>{result?.error === "no_match" ? "No match" : "Error"}</b>
              <p>
                {result?.error === "no_match"
                  ? "We could not recognise that one. Try again closer to the speakers."
                  : (result?.error ?? "Something went wrong.")}
              </p>
              <button type="button" className="step-button" onClick={refreshGate}>
                Try again
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
